//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ClientClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Clients
     * @return The list of Clients
     */
    getClients( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/client";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Client
     * @param body The Client data to create
     * @return The newly created Client data
     */
    createClient(body: ClientDTO, cancelToken?: CancelToken): Promise<ApiResponse_clientDTO> {
        let url_ = this.baseUrl + "/client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateClient(_response);
        });
    }

    protected processCreateClient(response: AxiosResponse): Promise<ApiResponse_clientDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_clientDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_clientDTO>(null as any);
    }

    /**
     * Retrieve a Client by ID
     * @param id The ID of the Client to retrieve
     * @return The Client data
     */
    getClientById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_clientDTO> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientById(_response);
        });
    }

    protected processGetClientById(response: AxiosResponse): Promise<ApiResponse_clientDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_clientDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_clientDTO>(null as any);
    }

    /**
     * Update a Client by ID
     * @param id The ID of the Client to update
     * @param body The updated Client data
     * @return The updated Client data
     */
    updateClient(id: string, body: ClientDTO, cancelToken?: CancelToken): Promise<ApiResponse_clientDTO> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateClient(_response);
        });
    }

    protected processUpdateClient(response: AxiosResponse): Promise<ApiResponse_clientDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_clientDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_clientDTO>(null as any);
    }

    /**
     * Delete a Client by ID
     * @param id The ID of the Client to delete
     */
    deleteClient(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteClient(_response);
        });
    }

    protected processDeleteClient(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Clients based on criteria
     * @param body The search criteria
     * @return The search results of Clients based on the criteria
     */
    searchClients(body: SearchRequestDTO_clientSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/client/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchClients(_response);
        });
    }

    protected processSearchClients(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class LeadFileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all LeadFiles
     * @return The list of LeadFiles
     */
    getLeadFiles( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/leadfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeadFiles(_response);
        });
    }

    protected processGetLeadFiles(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new LeadFile
     * @param body The LeadFile data to create
     * @return The newly created LeadFile data
     */
    createLeadFile(body: LeadFileDTO, cancelToken?: CancelToken): Promise<ApiResponse_leadFileDTO> {
        let url_ = this.baseUrl + "/leadfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLeadFile(_response);
        });
    }

    protected processCreateLeadFile(response: AxiosResponse): Promise<ApiResponse_leadFileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_leadFileDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadFileDTO>(null as any);
    }

    /**
     * Retrieve a LeadFile by ID
     * @param id The ID of the LeadFile to retrieve
     * @return The LeadFile data
     */
    getLeadFileById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_leadFileDTO> {
        let url_ = this.baseUrl + "/leadfile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeadFileById(_response);
        });
    }

    protected processGetLeadFileById(response: AxiosResponse): Promise<ApiResponse_leadFileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_leadFileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadFileDTO>(null as any);
    }

    /**
     * Update a LeadFile by ID
     * @param id The ID of the LeadFile to update
     * @param body The updated LeadFile data
     * @return The updated LeadFile data
     */
    updateLeadFile(id: string, body: LeadFileDTO, cancelToken?: CancelToken): Promise<ApiResponse_leadFileDTO> {
        let url_ = this.baseUrl + "/leadfile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLeadFile(_response);
        });
    }

    protected processUpdateLeadFile(response: AxiosResponse): Promise<ApiResponse_leadFileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_leadFileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadFileDTO>(null as any);
    }

    /**
     * Delete a LeadFile by ID
     * @param id The ID of the LeadFile to delete
     */
    deleteLeadFile(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/leadfile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLeadFile(_response);
        });
    }

    protected processDeleteLeadFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search LeadFiles based on criteria
     * @param body The search criteria
     * @return The search results of LeadFiles based on the criteria
     */
    searchLeadFiles(body: SearchRequestDTO_leadFileSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/leadfile/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchLeadFiles(_response);
        });
    }

    protected processSearchLeadFiles(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Uploads a lead file.
     * @param fileName (optional) The file name to use when saving the lead file
     * @param body The raw image file to upload
     * @return The URL of the uploaded lead file
     */
    uploadLeadFile(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/leadfile/upload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadLeadFile(_response);
        });
    }

    protected processUploadLeadFile(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a SAS token for a lead file.
     * @param leadFileId The ID of the lead file.
     * @return The SAS URL for the lead file.
     */
    generateLeadFileSas(leadFileId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/leadfile/{leadFileId}/download";
        if (leadFileId === undefined || leadFileId === null)
            throw new Error("The parameter 'leadFileId' must be defined.");
        url_ = url_.replace("{leadFileId}", encodeURIComponent("" + leadFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateLeadFileSas(_response);
        });
    }

    protected processGenerateLeadFileSas(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class LeadClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Leads
     * @return The list of Leads
     */
    getLeads( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/lead";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeads(_response);
        });
    }

    protected processGetLeads(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Lead
     * @param body The Lead data to create
     * @return The newly created Lead data
     */
    createLead(body: LeadDTO, cancelToken?: CancelToken): Promise<ApiResponse_leadDTO> {
        let url_ = this.baseUrl + "/lead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLead(_response);
        });
    }

    protected processCreateLead(response: AxiosResponse): Promise<ApiResponse_leadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_leadDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadDTO>(null as any);
    }

    /**
     * Retrieve a Lead by ID
     * @param id The ID of the Lead to retrieve
     * @return The Lead data
     */
    getLeadById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_leadDTO> {
        let url_ = this.baseUrl + "/lead/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeadById(_response);
        });
    }

    protected processGetLeadById(response: AxiosResponse): Promise<ApiResponse_leadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_leadDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadDTO>(null as any);
    }

    /**
     * Update a Lead by ID
     * @param id The ID of the Lead to update
     * @param body The updated Lead data
     * @return The updated Lead data
     */
    updateLead(id: string, body: LeadDTO, cancelToken?: CancelToken): Promise<ApiResponse_leadDTO> {
        let url_ = this.baseUrl + "/lead/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLead(_response);
        });
    }

    protected processUpdateLead(response: AxiosResponse): Promise<ApiResponse_leadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_leadDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadDTO>(null as any);
    }

    /**
     * Delete a Lead by ID
     * @param id The ID of the Lead to delete
     */
    deleteLead(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/lead/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLead(_response);
        });
    }

    protected processDeleteLead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Leads based on criteria
     * @param body The search criteria
     * @return The search results of Leads based on the criteria
     */
    searchLeads(body: SearchRequestDTO_leadSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/lead/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchLeads(_response);
        });
    }

    protected processSearchLeads(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Leadss based on search criteria
     * @param body The search criteria
     * @return The export results of leadss based on the search criteria
     */
    exportLeads(body: SearchRequestDTO_leadSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/lead/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportLeads(_response);
        });
    }

    protected processExportLeads(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class LeadStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all LeadStatuss
     * @return The list of LeadStatuss
     */
    getLeadStatuss( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/leadstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeadStatuss(_response);
        });
    }

    protected processGetLeadStatuss(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new LeadStatus
     * @param body The LeadStatus data to create
     * @return The newly created LeadStatus data
     */
    createLeadStatus(body: LeadStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_leadStatusDTO> {
        let url_ = this.baseUrl + "/leadstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLeadStatus(_response);
        });
    }

    protected processCreateLeadStatus(response: AxiosResponse): Promise<ApiResponse_leadStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_leadStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadStatusDTO>(null as any);
    }

    /**
     * Retrieve a LeadStatus by ID
     * @param id The ID of the LeadStatus to retrieve
     * @return The LeadStatus data
     */
    getLeadStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_leadStatusDTO> {
        let url_ = this.baseUrl + "/leadstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeadStatusById(_response);
        });
    }

    protected processGetLeadStatusById(response: AxiosResponse): Promise<ApiResponse_leadStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_leadStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadStatusDTO>(null as any);
    }

    /**
     * Update a LeadStatus by ID
     * @param id The ID of the LeadStatus to update
     * @param body The updated LeadStatus data
     * @return The updated LeadStatus data
     */
    updateLeadStatus(id: string, body: LeadStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_leadStatusDTO> {
        let url_ = this.baseUrl + "/leadstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLeadStatus(_response);
        });
    }

    protected processUpdateLeadStatus(response: AxiosResponse): Promise<ApiResponse_leadStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_leadStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_leadStatusDTO>(null as any);
    }

    /**
     * Delete a LeadStatus by ID
     * @param id The ID of the LeadStatus to delete
     */
    deleteLeadStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/leadstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLeadStatus(_response);
        });
    }

    protected processDeleteLeadStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search LeadStatuss based on criteria
     * @param body The search criteria
     * @return The search results of LeadStatuss based on the criteria
     */
    searchLeadStatuss(body: SearchRequestDTO_leadStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/leadstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchLeadStatuss(_response);
        });
    }

    protected processSearchLeadStatuss(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class NotesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Notess
     * @return The list of Notess
     */
    getNotess( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/notes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotess(_response);
        });
    }

    protected processGetNotess(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Notes
     * @param body The Notes data to create
     * @return The newly created Notes data
     */
    createNotes(body: NotesDTO, cancelToken?: CancelToken): Promise<ApiResponse_notesDTO> {
        let url_ = this.baseUrl + "/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNotes(_response);
        });
    }

    protected processCreateNotes(response: AxiosResponse): Promise<ApiResponse_notesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_notesDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_notesDTO>(null as any);
    }

    /**
     * Retrieve a Notes by ID
     * @param id The ID of the Notes to retrieve
     * @return The Notes data
     */
    getNotesById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_notesDTO> {
        let url_ = this.baseUrl + "/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotesById(_response);
        });
    }

    protected processGetNotesById(response: AxiosResponse): Promise<ApiResponse_notesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_notesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_notesDTO>(null as any);
    }

    /**
     * Update a Notes by ID
     * @param id The ID of the Notes to update
     * @param body The updated Notes data
     * @return The updated Notes data
     */
    updateNotes(id: string, body: NotesDTO, cancelToken?: CancelToken): Promise<ApiResponse_notesDTO> {
        let url_ = this.baseUrl + "/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNotes(_response);
        });
    }

    protected processUpdateNotes(response: AxiosResponse): Promise<ApiResponse_notesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_notesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_notesDTO>(null as any);
    }

    /**
     * Delete a Notes by ID
     * @param id The ID of the Notes to delete
     */
    deleteNotes(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNotes(_response);
        });
    }

    protected processDeleteNotes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Notess based on criteria
     * @param body The search criteria
     * @return The search results of Notess based on the criteria
     */
    searchNotess(body: SearchRequestDTO_notesSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/notes/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNotess(_response);
        });
    }

    protected processSearchNotess(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ProjectTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ProjectTypes
     * @return The list of ProjectTypes
     */
    getProjectTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/projecttype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectTypes(_response);
        });
    }

    protected processGetProjectTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ProjectType
     * @param body The ProjectType data to create
     * @return The newly created ProjectType data
     */
    createProjectType(body: ProjectTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_projectTypeDTO> {
        let url_ = this.baseUrl + "/projecttype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProjectType(_response);
        });
    }

    protected processCreateProjectType(response: AxiosResponse): Promise<ApiResponse_projectTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_projectTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_projectTypeDTO>(null as any);
    }

    /**
     * Retrieve a ProjectType by ID
     * @param id The ID of the ProjectType to retrieve
     * @return The ProjectType data
     */
    getProjectTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_projectTypeDTO> {
        let url_ = this.baseUrl + "/projecttype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectTypeById(_response);
        });
    }

    protected processGetProjectTypeById(response: AxiosResponse): Promise<ApiResponse_projectTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_projectTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_projectTypeDTO>(null as any);
    }

    /**
     * Update a ProjectType by ID
     * @param id The ID of the ProjectType to update
     * @param body The updated ProjectType data
     * @return The updated ProjectType data
     */
    updateProjectType(id: string, body: ProjectTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_projectTypeDTO> {
        let url_ = this.baseUrl + "/projecttype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProjectType(_response);
        });
    }

    protected processUpdateProjectType(response: AxiosResponse): Promise<ApiResponse_projectTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_projectTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_projectTypeDTO>(null as any);
    }

    /**
     * Delete a ProjectType by ID
     * @param id The ID of the ProjectType to delete
     */
    deleteProjectType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/projecttype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProjectType(_response);
        });
    }

    protected processDeleteProjectType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ProjectTypes based on criteria
     * @param body The search criteria
     * @return The search results of ProjectTypes based on the criteria
     */
    searchProjectTypes(body: SearchRequestDTO_projectTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/projecttype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProjectTypes(_response);
        });
    }

    protected processSearchProjectTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class PropertyTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all PropertyTypes
     * @return The list of PropertyTypes
     */
    getPropertyTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/propertytype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPropertyTypes(_response);
        });
    }

    protected processGetPropertyTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new PropertyType
     * @param body The PropertyType data to create
     * @return The newly created PropertyType data
     */
    createPropertyType(body: PropertyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_propertyTypeDTO> {
        let url_ = this.baseUrl + "/propertytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePropertyType(_response);
        });
    }

    protected processCreatePropertyType(response: AxiosResponse): Promise<ApiResponse_propertyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_propertyTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_propertyTypeDTO>(null as any);
    }

    /**
     * Retrieve a PropertyType by ID
     * @param id The ID of the PropertyType to retrieve
     * @return The PropertyType data
     */
    getPropertyTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_propertyTypeDTO> {
        let url_ = this.baseUrl + "/propertytype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPropertyTypeById(_response);
        });
    }

    protected processGetPropertyTypeById(response: AxiosResponse): Promise<ApiResponse_propertyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_propertyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_propertyTypeDTO>(null as any);
    }

    /**
     * Update a PropertyType by ID
     * @param id The ID of the PropertyType to update
     * @param body The updated PropertyType data
     * @return The updated PropertyType data
     */
    updatePropertyType(id: string, body: PropertyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_propertyTypeDTO> {
        let url_ = this.baseUrl + "/propertytype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePropertyType(_response);
        });
    }

    protected processUpdatePropertyType(response: AxiosResponse): Promise<ApiResponse_propertyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_propertyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_propertyTypeDTO>(null as any);
    }

    /**
     * Delete a PropertyType by ID
     * @param id The ID of the PropertyType to delete
     */
    deletePropertyType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/propertytype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePropertyType(_response);
        });
    }

    protected processDeletePropertyType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search PropertyTypes based on criteria
     * @param body The search criteria
     * @return The search results of PropertyTypes based on the criteria
     */
    searchPropertyTypes(body: SearchRequestDTO_propertyTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/propertytype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPropertyTypes(_response);
        });
    }

    protected processSearchPropertyTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ProvinceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Provinces
     * @return The list of Provinces
     */
    getProvinces( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/province";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProvinces(_response);
        });
    }

    protected processGetProvinces(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Province
     * @param body The Province data to create
     * @return The newly created Province data
     */
    createProvince(body: ProvinceDTO, cancelToken?: CancelToken): Promise<ApiResponse_provinceDTO> {
        let url_ = this.baseUrl + "/province";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProvince(_response);
        });
    }

    protected processCreateProvince(response: AxiosResponse): Promise<ApiResponse_provinceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_provinceDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_provinceDTO>(null as any);
    }

    /**
     * Retrieve a Province by ID
     * @param id The ID of the Province to retrieve
     * @return The Province data
     */
    getProvinceById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_provinceDTO> {
        let url_ = this.baseUrl + "/province/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProvinceById(_response);
        });
    }

    protected processGetProvinceById(response: AxiosResponse): Promise<ApiResponse_provinceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_provinceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_provinceDTO>(null as any);
    }

    /**
     * Update a Province by ID
     * @param id The ID of the Province to update
     * @param body The updated Province data
     * @return The updated Province data
     */
    updateProvince(id: string, body: ProvinceDTO, cancelToken?: CancelToken): Promise<ApiResponse_provinceDTO> {
        let url_ = this.baseUrl + "/province/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProvince(_response);
        });
    }

    protected processUpdateProvince(response: AxiosResponse): Promise<ApiResponse_provinceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_provinceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_provinceDTO>(null as any);
    }

    /**
     * Delete a Province by ID
     * @param id The ID of the Province to delete
     */
    deleteProvince(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/province/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProvince(_response);
        });
    }

    protected processDeleteProvince(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Provinces based on criteria
     * @param body The search criteria
     * @return The search results of Provinces based on the criteria
     */
    searchProvinces(body: SearchRequestDTO_provinceSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/province/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProvinces(_response);
        });
    }

    protected processSearchProvinces(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class RecordStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all RecordStatuss
     * @return The list of RecordStatuss
     */
    getRecordStatuss( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/recordstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecordStatuss(_response);
        });
    }

    protected processGetRecordStatuss(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new RecordStatus
     * @param body The RecordStatus data to create
     * @return The newly created RecordStatus data
     */
    createRecordStatus(body: RecordStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_recordStatusDTO> {
        let url_ = this.baseUrl + "/recordstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRecordStatus(_response);
        });
    }

    protected processCreateRecordStatus(response: AxiosResponse): Promise<ApiResponse_recordStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_recordStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_recordStatusDTO>(null as any);
    }

    /**
     * Retrieve a RecordStatus by ID
     * @param id The ID of the RecordStatus to retrieve
     * @return The RecordStatus data
     */
    getRecordStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_recordStatusDTO> {
        let url_ = this.baseUrl + "/recordstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecordStatusById(_response);
        });
    }

    protected processGetRecordStatusById(response: AxiosResponse): Promise<ApiResponse_recordStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_recordStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_recordStatusDTO>(null as any);
    }

    /**
     * Update a RecordStatus by ID
     * @param id The ID of the RecordStatus to update
     * @param body The updated RecordStatus data
     * @return The updated RecordStatus data
     */
    updateRecordStatus(id: string, body: RecordStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_recordStatusDTO> {
        let url_ = this.baseUrl + "/recordstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRecordStatus(_response);
        });
    }

    protected processUpdateRecordStatus(response: AxiosResponse): Promise<ApiResponse_recordStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_recordStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_recordStatusDTO>(null as any);
    }

    /**
     * Delete a RecordStatus by ID
     * @param id The ID of the RecordStatus to delete
     */
    deleteRecordStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/recordstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRecordStatus(_response);
        });
    }

    protected processDeleteRecordStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search RecordStatuss based on criteria
     * @param body The search criteria
     * @return The search results of RecordStatuss based on the criteria
     */
    searchRecordStatuss(body: SearchRequestDTO_recordStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/recordstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRecordStatuss(_response);
        });
    }

    protected processSearchRecordStatuss(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class AuditLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve an audit log by ID
     * @param id The ID of the audit log to retrieve
     * @return The audit log data
     */
    getAuditLogById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_auditLogDTO> {
        let url_ = this.baseUrl + "/auditlogs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLogById(_response);
        });
    }

    protected processGetAuditLogById(response: AxiosResponse): Promise<ApiResponse_auditLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_auditLogDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_auditLogDTO>(null as any);
    }

    /**
     * Search audit logs based on criteria
     * @param body The search criteria
     * @return The search results of audit logs based on the criteria
     */
    searchAuditLogs(body: SearchRequestDTO_auditLogSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/auditlogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAuditLogs(_response);
        });
    }

    protected processSearchAuditLogs(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Retrieve distinct table names
     * @return The list of distinct table names
     */
    getDistinctTableNames( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/auditlogs/tablenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDistinctTableNames(_response);
        });
    }

    protected processGetDistinctTableNames(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Generates a token for user authentication
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    generateToken(body: LoginUserDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateToken(_response);
        });
    }

    protected processGenerateToken(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for user authentication via two factor authentication
     * @param body Two factor auth data for token generation
     * @return JWT token for authenticated requests
     */
    generateTokenTwoFactor(body: LoginTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/twofactor/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateTokenTwoFactor(_response);
        });
    }

    protected processGenerateTokenTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect credentials.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Refreshes an access token
     * @param body Payload containing the refresh token
     * @return The refreshed access token, refresh token, and expiration time.
     */
    refreshToken(body: RefreshTokenDTO, cancelToken?: CancelToken): Promise<ApiResponse_authDTO> {
        let url_ = this.baseUrl + "/auth/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_authDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_authDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request in case of invalid refresh token.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the refresh token is expired or invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_authDTO>(null as any);
    }

    /**
     * Setup Two-Factor Authentication
     * @param userId The ID of the user
     * @return TOTP setup details including QR code and secret
     */
    setupTwoFactor(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        let url_ = this.baseUrl + "/auth/{userId}/two-factor/setup";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupTwoFactor(_response);
        });
    }

    protected processSetupTwoFactor(response: AxiosResponse): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(null as any);
    }

    /**
     * Verify Two-Factor Authentication Code
     * @param body Payload containing the TOTP code and user ID.
     * @return Verification success message.
     */
    verifyTwoFactor(body: VerifyTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/two-factor/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyTwoFactor(_response);
        });
    }

    protected processVerifyTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request if the payload is invalid.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the TOTP code is invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Validates a Google sign in token and returns JWT token
     * @param body Google sign in token
     * @return JWT token for authenticated requests
     */
    googleTokenExchange(body: TokenExchangeDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/tokenexchange/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleTokenExchange(_response);
        });
    }

    protected processGoogleTokenExchange(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, invalid Google sign in token", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when impersonating a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogin(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogin(_response);
        });
    }

    protected processImpersonateMemberLogin(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when loggin out of a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogout(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogout(_response);
        });
    }

    protected processImpersonateMemberLogout(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class BulkEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all bulk email statuses.
     * @return List of bulk email statuses.
     */
    getAllBulkEmailStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBulkEmailStatuses(_response);
        });
    }

    protected processGetAllBulkEmailStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Process a bulk email
     * @param id The ID of the bulk email to process
     * @return The processed bulk email data
     */
    processBulkEmail(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}/process";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessBulkEmail(_response);
        });
    }

    protected processProcessBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request response if processing fails", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Server error response", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve all bulk emails
     * @return The list of bulk emails
     */
    getBulkEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmails(_response);
        });
    }

    protected processGetBulkEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new bulk email
     * @param body The bulk email data to create
     * @return The newly created bulk email data
     */
    createBulkEmail(body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkEmail(_response);
        });
    }

    protected processCreateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve a bulk email by ID
     * @param id The ID of the bulk email to retrieve
     * @return The bulk email data
     */
    getBulkEmailById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmailById(_response);
        });
    }

    protected processGetBulkEmailById(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Update a bulk email by ID
     * @param id The ID of the bulk email to update
     * @param body The updated bulk email data
     * @return The updated bulk email data
     */
    updateBulkEmail(id: string, body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBulkEmail(_response);
        });
    }

    protected processUpdateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Delete a bulk email by ID
     * @param id The ID of the bulk email to delete
     */
    deleteBulkEmail(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBulkEmail(_response);
        });
    }

    protected processDeleteBulkEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a bulk email attachment
     * @param fileName (optional) Optional file name for saving the file. If not provided, a unique name will be generated.
     * @param body The raw file content to upload
     * @return The relative path of the uploaded file
     */
    uploadBulkEmailAttachment(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/bulkemails/attachments/upload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBulkEmailAttachment(_response);
        });
    }

    protected processUploadBulkEmailAttachment(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request: Invalid file or missing parameters.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("An error occurred while uploading the file.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search bulk emails based on criteria
     * @param body The search criteria
     * @return The search results of bulk emails based on the criteria
     */
    searchBulkEmails(body: SearchRequestDTO_bulkEmailSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/bulkemails/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBulkEmails(_response);
        });
    }

    protected processSearchBulkEmails(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CommunicationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Unsubscribe an email using a token.
     * @param body Token data for unsubscribing an email.
     * @return Result of the unsubscribe action.
     */
    unsubscribeEmail(body: UnsubscribedEmailRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/communication/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeEmail(_response);
        });
    }

    protected processUnsubscribeEmail(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve all unsubscribed emails.
     * @return List of unsubscribed emails.
     */
    getAllUnsubscribedEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/unsubscribed-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUnsubscribedEmails(_response);
        });
    }

    protected processGetAllUnsubscribedEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Retrieve all communication lists.
     * @return List of communication lists.
     */
    getAllCommunicationLists( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/lists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCommunicationLists(_response);
        });
    }

    protected processGetAllCommunicationLists(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class CompanyInfoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all company infos
     * @return The list of company infos
     */
    getCompanyInfos( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfos(_response);
        });
    }

    protected processGetCompanyInfos(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new company info
     * @param body The company info data to create
     * @return The newly created data.
     */
    createCompanyInfo(body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompanyInfo(_response);
        });
    }

    protected processCreateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Retrieve a company info by ID
     * @param id The ID of the company info to retrieve
     * @return The company info data
     */
    getCompanyInfoById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfoById(_response);
        });
    }

    protected processGetCompanyInfoById(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Update a company info by ID
     * @param id The ID of the company info to update
     * @param body The updated company info data
     * @return The updated company info data.
     */
    updateCompanyInfo(id: string, body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompanyInfo(_response);
        });
    }

    protected processUpdateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Delete a company info by ID
     * @param id The ID of the company info to delete
     */
    deleteCompanyInfo(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompanyInfo(_response);
        });
    }

    protected processDeleteCompanyInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search company infos based on criteria
     * @param body The search criteria
     * @return The search results of company info based on the criteria
     */
    searchCompanyInfos(body: SearchRequestDTO_companyInfoSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/companyinfos/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompanyInfos(_response);
        });
    }

    protected processSearchCompanyInfos(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class DashboardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Get a list of leads for user.
     * @return Payload of ApiResponse containing SearchResponseDTO
     */
    getUserLeads(body: SearchRequestDTO_dashboardLeadCountSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/dashboard/user/leads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserLeads(_response);
        });
    }

    protected processGetUserLeads(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Members
     * @return The list of members
     */
    getMembers( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMembers(_response);
        });
    }

    protected processGetMembers(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Member
     * @param body The Member data to create
     * @return The newly created Member data
     */
    createMember(body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMember(_response);
        });
    }

    protected processCreateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Retrieve a Member by ID
     * @param id The ID of the Member to retrieve
     * @return The Member data
     */
    getMemberById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberById(_response);
        });
    }

    protected processGetMemberById(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Update a Member by ID
     * @param id The ID of the Member to update
     * @param body The updated Member data
     * @return The updated Member data
     */
    updateMember(id: string, body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMember(_response);
        });
    }

    protected processUpdateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Delete a Member by ID
     * @param id The ID of the Member to delete
     */
    deleteMember(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMember(_response);
        });
    }

    protected processDeleteMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Members based on criteria
     * @param body The search criteria
     * @return The search results of Members based on the criteria
     */
    searchMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/member/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMembers(_response);
        });
    }

    protected processSearchMembers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Checks if an email exists.
     * @param email The email address.
     * @return Payload of ApiResponse containing Boolean
     */
    checkEmailExists(email: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/users/check-email?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmailExists(_response);
        });
    }

    protected processCheckEmailExists(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Get a user by ID
     * @param id The ID of the user to fetch
     * @return Payload of ApiResponse containing UserDTO
     */
    getUserById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Update an existing user
     * @return Payload of ApiResponse containing UserEditDTO
     */
    updateUser(id: string, body: UserEditDTO, cancelToken?: CancelToken): Promise<ApiResponse_userEditDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ApiResponse_userEditDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userEditDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userEditDTO>(null as any);
    }

    /**
     * Deletes an existing user
     * @return Payload of ApiResponse containing String
     */
    deleteUser(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search for users
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    searchUsers(body: SearchRequestDTO_userSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/user/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Create a new user
     * @return Payload of ApiResponse containing UserDTO
     */
    createUser(body: UserCreateDTO, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_userDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Generates a password reset link
     * @return Payload of ApiResponse containing String
     */
    forgotPassword(body: ForgotPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Resets a user's password using a reset token
     * @return Payload of ApiResponse containing String
     */
    resetPassword(body: ResetPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Uploads a users profile picture.
     * @param fileName (optional) The file name to use when saving the image
     * @param body The raw image file to upload
     * @return The URL of the uploaded image
     */
    uploadProfilePicture(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/upload-profile-picture?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProfilePicture(_response);
        });
    }

    protected processUploadProfilePicture(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a SAS token for a user's profile picture.
     * @param userId The ID of the user.
     * @return The SAS URL for the profile picture.
     */
    generateProfilePictureSas(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/users/{userId}/profile-picture";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateProfilePictureSas(_response);
        });
    }

    protected processGenerateProfilePictureSas(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get all roles
     * @return Payload of ApiResponse containing Roles
     */
    getRoles( cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/user/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Roles not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }
}

export interface ApiResponse_auditLogDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuditLogDTO | undefined;
}

export interface ApiResponse_authDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuthDTO | undefined;
}

export interface ApiResponse_boolean {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: boolean | undefined;
}

export interface ApiResponse_bulkEmailDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BulkEmailDTO | undefined;
}

export interface ApiResponse_clientDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ClientDTO | undefined;
}

export interface ApiResponse_companyInfoDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompanyInfoDTO | undefined;
}

export interface ApiResponse_iEnumerable_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ClientDTO[] | undefined;
}

export interface ApiResponse_leadDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: LeadDTO | undefined;
}

export interface ApiResponse_leadFileDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: LeadFileDTO | undefined;
}

export interface ApiResponse_leadStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: LeadStatusDTO | undefined;
}

export interface ApiResponse_list_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RoleDTO[] | undefined;
}

export interface ApiResponse_memberDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberDTO | undefined;
}

export interface ApiResponse_notesDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NotesDTO | undefined;
}

export interface ApiResponse_projectTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ProjectTypeDTO | undefined;
}

export interface ApiResponse_propertyTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PropertyTypeDTO | undefined;
}

export interface ApiResponse_provinceDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ProvinceDTO | undefined;
}

export interface ApiResponse_recordStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RecordStatusDTO | undefined;
}

export interface ApiResponse_searchResponseDTO_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SearchResponseDTO_clientDTO | undefined;
}

export interface ApiResponse_string {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_twoFactorSetupResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: TwoFactorSetupResponseDTO | undefined;
}

export interface ApiResponse_userDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserDTO | undefined;
}

export interface ApiResponse_userEditDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserEditDTO | undefined;
}

export interface AuditLogDTO {
    action?: string | undefined;
    tableName?: string | undefined;
    recordId?: string | undefined;
    propertyName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdUtc?: string | undefined;
    updatedUtc?: string | undefined;
    changedBy?: string | undefined;
}

export interface AuditLogSearchRequestDTO {
    tableName?: string | undefined;
    recordId?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export interface AuthDTO {
    accessToken?: string | undefined;
    expiresAt?: number | undefined;
    refreshToken?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
}

export interface BulkEmailDTO {
    id?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    bulkEmailStatusId?: string | undefined;
    communicationListId?: string | undefined;
    totalCount?: number | undefined;
    totalCountProcessed?: number | undefined;
    attachmentPath?: string | undefined;
    bulkEmailStatusName?: string | undefined;
    communicationListName?: string | undefined;
}

export interface BulkEmailSearchRequestDTO {
    subject?: string | undefined;
}

export interface ClientDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    companyName?: string | undefined;
    contactPerson?: string | undefined;
    number?: string | undefined;
    email?: string | undefined;
}

export interface ClientSearchRequestDTO {
    companyName?: string | undefined;
    contactPerson?: string | undefined;
    number?: string | undefined;
    email?: string | undefined;
}

export interface CompanyInfoDTO {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface CompanyInfoSearchRequestDTO {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface DashboardLeadCountSearchRequestDTO {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface ForgotPasswordDTO {
    email: string;
}

export interface ImpersonationDTO {
    memberId?: string | undefined;
    adminId?: string | undefined;
}

export interface LeadDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    companyName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    provinceId?: string | undefined;
    projectTypeId?: string | undefined;
    projectDetails?: string | undefined;
    energyConsumptionKWh?: number | undefined;
    propertyTypeId?: string | undefined;
    propertySize?: string | undefined;
    budget?: number | undefined;
    financingOption?: boolean | undefined;
    technicalRequirements?: string | undefined;
    projectTimeline?: Date | undefined;
    maintenanceSupport?: boolean | undefined;
    environmentalImpactInterest?: string | undefined;
    leadStatusId?: string | undefined;
    projectTypeName?: string | undefined;
    createdByName?: string | undefined;
    lastNote?: string | undefined;
}

export interface LeadFileDTO {
    id?: string | undefined;
    leadId?: string | undefined;
    fileName?: string | undefined;
    friendlyName?: string | undefined;
}

export interface LeadFileSearchRequestDTO {
    leadId?: string | undefined;
    fileName?: string | undefined;
}

export interface LeadSearchRequestDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    companyName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    provinceId?: string | undefined;
    projectTypeId?: string | undefined;
    projectDetails?: string | undefined;
    energyConsumptionKWh?: number | undefined;
    propertyTypeId?: string | undefined;
    propertySize?: string | undefined;
    budget?: number | undefined;
    financingOption?: boolean | undefined;
    technicalRequirements?: string | undefined;
    projectTimeline?: Date | undefined;
    maintenanceSupport?: boolean | undefined;
    environmentalImpactInterest?: string | undefined;
    leadStatusId?: string | undefined;
    createdBy?: string | undefined;
}

export interface LeadStatusDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface LeadStatusSearchRequestDTO {
    name?: string | undefined;
}

export interface LoginTwoFactorDTO {
    email?: string | undefined;
    tempToken?: string | undefined;
    code?: string | undefined;
}

export interface LoginUserDTO {
    email: string;
    password: string;
}

export interface MemberDTO {
    id?: string | undefined;
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    userID?: string | undefined;
}

export interface MemberSearchRequestDTO {
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface NotesDTO {
    id?: string | undefined;
    leadId?: string | undefined;
    text?: string | undefined;
    createdUtc?: Date | undefined;
}

export interface NotesSearchRequestDTO {
    leadId?: string | undefined;
    text?: string | undefined;
}

export interface ProjectTypeDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface ProjectTypeSearchRequestDTO {
    name?: string | undefined;
}

export interface PropertyTypeDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface PropertyTypeSearchRequestDTO {
    name?: string | undefined;
}

export interface ProvinceDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface ProvinceSearchRequestDTO {
    name?: string | undefined;
}

export interface RecordStatusDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface RecordStatusSearchRequestDTO {
    name?: string | undefined;
}

export interface RefreshTokenDTO {
    refreshToken?: string | undefined;
}

export interface ResetPasswordDTO {
    email?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export interface RoleDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface SearchRequestDTO_auditLogSearchRequestDTO {
    filters?: AuditLogSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_bulkEmailSearchRequestDTO {
    filters?: BulkEmailSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_clientSearchRequestDTO {
    filters?: ClientSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_companyInfoSearchRequestDTO {
    filters?: CompanyInfoSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_dashboardLeadCountSearchRequestDTO {
    filters?: DashboardLeadCountSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_leadFileSearchRequestDTO {
    filters?: LeadFileSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_leadSearchRequestDTO {
    filters?: LeadSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_leadStatusSearchRequestDTO {
    filters?: LeadStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberSearchRequestDTO {
    filters?: MemberSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_notesSearchRequestDTO {
    filters?: NotesSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_projectTypeSearchRequestDTO {
    filters?: ProjectTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_propertyTypeSearchRequestDTO {
    filters?: PropertyTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_provinceSearchRequestDTO {
    filters?: ProvinceSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_recordStatusSearchRequestDTO {
    filters?: RecordStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_userSearchRequestDTO {
    filters?: UserSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchResponseDTO_clientDTO {
    results?: ClientDTO[] | undefined;
    totalCount?: number | undefined;
}

export interface TokenExchangeDTO {
    token?: string | undefined;
}

export interface TwoFactorSetupResponseDTO {
    qrCodeUrl?: string | undefined;
}

export interface UnsubscribedEmailRequestDTO {
    token?: string | undefined;
    reason?: string | undefined;
}

export interface UserCreateDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    roleId?: string | undefined;
}

export interface UserDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    roleId?: string | undefined;
    jobTitle?: string | undefined;
}

export interface UserEditDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    roleId?: string | undefined;
}

export interface UserSearchRequestDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
}

export interface VerifyTwoFactorDTO {
    userId?: string | undefined;
    code?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}